import mentoriaAxios from '../axiosTokenMiddleware';

const mentoriaFinancieraURL = process.env.REACT_APP_MENTORIA_FINANCIERA_URL;
const mentoriaFinancieraApiKey = process.env.REACT_APP_MENTORIA_FINANCIERA_API_KEY;

export function getProfileByUser () {
	return mentoriaAxios.get(mentoriaFinancieraURL + 'getProfileByUser', {
		headers: {
			ApiKey: mentoriaFinancieraApiKey,
		},
	});
}

export function getFinancialProductsByUser () {
	return mentoriaAxios.get(mentoriaFinancieraURL + 'getFinancialProduct', {
		headers: {
			ApiKey: mentoriaFinancieraApiKey,
		},
	});
}